module.exports = __webpack_public_path__ + "543c5f254ece88e9567b510fbba57152.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-38.png
// module id = 123
// module chunks = 0